import React from 'react';
import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';
import { Checkbox } from '../../../../../app/form/checkbox/checkbox';
import { routes } from '../../../../../../config/routes';
import { useRootStore } from '../../../../../../providers/root-store-provider';

interface AgreeMarketingProps {
    handleChange?: (e: React.ChangeEvent<never>) => void;
}

export const AgreeMarketing: React.FC<AgreeMarketingProps> = observer(({ handleChange }) => {
    const {
        authStore: { authDialogStore },
    } = useRootStore();

    const onChange = () => {
        authDialogStore.switchAgreedMarketing();

        if (handleChange) {
            handleChange({
                target: {
                    name: 'agreedMarketing',
                    value: authDialogStore.agreedMarketing,
                },
            } as React.ChangeEvent<never>);
        }
    };

    return (
        <div className="inline-flex rounded-small py-[0.8rem] pl-[1.8rem] [&_label_.MuiCheckbox-root]:-m-[0.9rem] [&_label_.MuiCheckbox-root]:mr-0">
            <Checkbox
                name="agreedMarketing"
                checked={authDialogStore.agreedMarketing}
                onChange={onChange}
                label={
                    <Trans
                        i18nKey={'layout.forms.common.agreeMarketing'}
                        components={{
                            marketing: (
                                <a href={routes.web.marketingCommunicationTerms} target={'_blank'} rel="noreferrer">
                                    Link
                                </a>
                            ),
                        }}
                    />
                }
            />
        </div>
    );
});
